module.exports = __webpack_public_path__ + "static/img/zhuye.db0a4e0b.png";